<script setup>
import { computed } from 'vue';
import PotentialDropdown from '@/components/PotentialDropdown.vue';

const props = defineProps({
  isDesktop: { type: Boolean, default: false },
  offersWithFeedback: { type: Array, default: () => [] },
  offersForSalesPitch: { type: Array, default: () => [] },
  availablePotentialProducts: { type: Array, default: () => [] },
  newProductForAppointment: { type: [String, Number], default: -1 },
  offerList: { type: Array, default: () => [] },
  warning: { type: Boolean, default: false },
  onAddProduct: { type: Function, required: true },
  onRemoveProduct: { type: Function, required: true },
  onUpdateNewProductForAppointment: { type: Function, required: true }
});
import { defineEmits } from 'vue';
const emit = defineEmits(['remove-product']);

const potentialCount = computed(() => (props.offerList || []).filter(o => o?.status?.id === 16).length);

// Hilfsfunktion: Ist ein Produkt aus dem Dropdown ausgewählt?
const isValidProductSelection = computed(() => {
  const val = props.newProductForAppointment;
  if (val === null || val === undefined) return false;
  if (typeof val === 'number') return val > 0;
  if (typeof val === 'string') {
    const m = val.match(/(\d+)$/);
    return m ? parseInt(m[1], 10) > 0 : false;
  }
  return false;
});

function handleRemoveProduct(productId) {
  emit('remove-product', productId);
  if (props.onRemoveProduct) props.onRemoveProduct(productId);
}
</script>

<template>
  <div :class="['accordion-menu potential', { 'warning': warning, 'preventOnDesktop': isDesktop }]">
    <ul class="main-list">
      <li class="main-list-item">
        <input v-if="isDesktop" type="checkbox" checked disabled>
        <input v-else type="checkbox">
        <i class="arrow"></i>
        <h3>Potentiale</h3>
        <div class="accordion-content-wrapper">
          <div class="potential-details-content">
            <div class="potentiale-edited">
              <h4>Potential Feedback</h4>
              <div class="info-wrapper container edited" v-if="offersWithFeedback.length === 0">Kein Potential mit Feedback vorhanden.</div>
              <div class="info-wrapper container edited" v-for="offer in offersWithFeedback" :key="offer.product.id">
                <div class="select-wrapper">
                  <p :title="
                        offer.status.id === 16 ? 'Potential' : 
                        offer.status.id === 23 ? 'Wird im nächsten Termin besprochen' : 
                        offer.status.id === 21 ? 'Wurde vom Kunden abgelehnt' : 
                        offer.status.id === 19 ? 'Wurde vom Kunden persönlich angenommen' : 
                        offer.status.id === 20 ? 'Wurde vom Kunden telefonisch angenommen' : 
                        offer.status.id === 28 ? 'Wurde im Termin nicht besprochen' : 
                        offer.status.id === 18 ? 'Wurde in die nächste Kampagne verschoben' : 
                        ''" 
                    :class="{['_' + offer.status.id]: true }">{{offer.product.name}}</p>
                </div>
              </div>
            </div>
            <div class="potentiale-pending">
              <h4>Beim Termin besprechen</h4>
              <div class="wrapper">
                <div class="info-wrapper container" v-for="offer in offerList.filter(o => o.status?.id === 16)" :key="offer.product.id">
                  <div class="select-wrapper">
                    <p
                      :title="
                        offer.status.id === 16 ? 'Potential' :
                        offer.status.id === 23 ? 'Wird im nächsten Termin besprochen' :
                        offer.status.id === 21 ? 'Wurde vom Kunden abgelehnt' :
                        offer.status.id === 19 ? 'Wurde vom Kunden persönlich angenommen' :
                        offer.status.id === 20 ? 'Wurde vom Kunden telefonisch angenommen' :
                        offer.status.id === 28 ? 'Wurde im Termin nicht besprochen' :
                        offer.status.id === 18 ? 'Wurde in die nächste Kampagne verschoben' :
                        ''
                      "
                      :class="'_' + offer.status.id"
                    >
                      {{ offer.product.name }}
                    </p>
                    <!-- <button v-if="offer.status.id === 16" @click="onRemoveProduct(offer.product.id)"></button> -->
                    <button v-if="offer.status.id === 16" @click="handleRemoveProduct(offer.product.id)"></button>
                  </div>
                </div>
              </div>
              <div class="add-potential-wrapper container">
                <PotentialDropdown
                  :options="availablePotentialProducts"
                  trigger-label="Bitte Potential auswählen"
                  placeholder="Bitte Potential auswählen"
                  :model-value="newProductForAppointment"
                  @update:modelValue="onUpdateNewProductForAppointment"
                />
                <button
                  @click="onAddProduct()"
                  class="add-potential"
                  :disabled="!isValidProductSelection"
                  :title="!isValidProductSelection ? 'Bitte zuerst ein Potential auswählen' : 'Potential hinzufügen'"
                ></button>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
